import {
  CREATE_AUTO_ON_REQUEST,
  CREATE_DRIVER_ON_REQUEST,
  SET_CARS_ON_REQUEST,
  SET_DRIVER_ON_REQUEST,
  UPDATE_AUTOMOBILE_ON_REQUEST,
  UPDATE_DRIVER_ON_REQUEST,
} from '@/store/actions/responseRequest'
import { Message } from 'element-ui'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { SET_LOADING } from './actions/responses'
import Vue from 'vue'
import deepMerge from '@/helpers/deepMerge'

const api = RepositoryFactory.get('responseRequest')

export default {
  namespaced: true,
  state: {
    driverList: [],
    automobileList: [],
    loadingDriver: false,
    loadingAutomobile: false,
  },
  getters: {
    getDrivers: state => state.driverList,
    getAutomobile: state => state.automobileList,
    getLoading:
      state =>
      (type = '') =>
        state['loading' + type],
  },
  actions: {
    async fetchDrivers({ commit }, driverList) {
      try {
        commit(SET_LOADING, { flag: true })
        const { data } = await api.fetchDriverList(driverList)

        commit(SET_DRIVER_ON_REQUEST, data)
      } catch (error) {
        Message({
          type: 'error',
          showClose: true,
          message: 'Произошла неизвестная ошибка',
        })
      } finally {
        commit(SET_LOADING, { flag: false })
      }
    },
    async fetchAutomobileList({ commit }, driverList) {
      try {
        commit(SET_LOADING, { flag: true })
        const { data } = await api.fetchAutomobileList(driverList)

        commit(SET_CARS_ON_REQUEST, data)
      } catch (error) {
        Message({
          type: 'error',
          showClose: true,
          message: 'Произошла неизвестная ошибка',
        })
      } finally {
        commit(SET_LOADING, { flag: false })
      }
    },
    changeDriverOwner({ commit }, driver) {
      commit(SET_LOADING, { flag: true })
      api
        .changeDriverOwner(driver)
        .then(res => {
          if (res.data) {
            commit(UPDATE_DRIVER_ON_REQUEST, driver)
            Message({
              type: 'success',
              showClose: true,
              message: 'Водитель привязан',
            })
          }
        })
        .catch(e => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
        })
        .finally(() => commit(SET_LOADING, { flag: false }))
    },
    addDriverToResponse({ commit }, driver) {
      commit(SET_LOADING, { flag: true })
      api
        .addDriver(driver)
        .then(res => {
          if (res.data) {
            commit('loadDay/updateResponsesInProgress', res.data, {
              root: true,
            }) // -> 'someMutation'

            Message({
              type: 'success',
              showClose: true,
              message: 'Водитель привязан',
            })
          }
        })
        .catch(e => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
        })
        .finally(() => commit(SET_LOADING, { flag: false }))
    },
    addAutomobileToResponse({ commit }, auto) {
      commit(SET_LOADING, { flag: true })
      api
        .addAutomobile(auto)
        .then(res => {
          if (res.data) {
            commit('loadDay/updateResponsesInProgress', res.data, {
              root: true,
            }) // -> 'someMutation'

            // commit(UPDATE_DRIVER_ON_REQUEST, driver)
            Message({
              type: 'success',
              showClose: true,
              message: 'Автомобиль добавлен',
            })
          }
        })
        .catch(e => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
        })
        .finally(() => commit(SET_LOADING, { flag: false }))
    },
    changeAutomobileOwner({ commit }, auto) {
      commit(SET_LOADING, { flag: true, type: 'Automobile' })
      api
        .changeAutomobleOwner(auto)
        .then(res => {
          if (res.data) {
            commit(UPDATE_AUTOMOBILE_ON_REQUEST, auto)
            Message({
              type: 'success',
              showClose: true,
              message: 'Автомобиль привязан',
            })
          }
        })
        .catch(e => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
        })
        .finally(() => commit(SET_LOADING, { flag: false, type: 'Automobile' }))
    },
  },
  mutations: {
    [SET_LOADING](state, { flag, type = '' }) {
      state['loading' + type] = Boolean(flag)
    },
    [SET_DRIVER_ON_REQUEST](state, payload) {
      state.driverList = payload
    },
    [SET_CARS_ON_REQUEST](state, payload) {
      state.automobileList = payload
    },
    [UPDATE_DRIVER_ON_REQUEST](state, payload) {
      let findIndex = state.driverList.findIndex(
        item => item.id == payload.driver_id,
      )
      let updateObj = { ...state.driverList[findIndex], user_id_match: 1 }

      if (findIndex > -1) {
        Vue.set(
          state.driverList,
          findIndex,
          deepMerge(state.driverList[findIndex], updateObj),
        )
      }
    },
    [CREATE_DRIVER_ON_REQUEST](state, payload) {
      state.driverList.unshift(payload)
    },
    [CREATE_AUTO_ON_REQUEST](state, payload) {
      state.automobileList.unshift(payload)
    },
    [UPDATE_AUTOMOBILE_ON_REQUEST](state, payload) {
      let findIndex = state.automobileList.findIndex(
        item => item.id == payload.automobile_id,
      )
      let updateObj = { ...state.automobileList[findIndex], user_id_match: 1 }

      if (findIndex > -1) {
        Vue.set(
          state.automobileList,
          findIndex,
          deepMerge(state.automobileList[findIndex], updateObj),
        )
      }
    },
  },
}
